module.exports = __webpack_public_path__ + "static/AnjanaSinha.2055132b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mentImg/AnjanaSinha.jpg
// module id = 239
// module chunks = 25111403944408 251948199435738